import {GameObject, HelperFunctions} from "../../tsthree";
import { Container, Graphics, NineSlicePlane, Rectangle, Renderer, Sprite, Text, TextStyle, Texture } from "pixi.js";
import {tsthreeConfig} from "../../config/tsthreeConfig";
import {buttonify} from "../../engine/HelperFunctions/buttonify";
import {GAME_FONT, GAME_FONT_BOLD} from "../Constants/Constants";
import {IWindowState} from "../Types/IWindowState";
import {Windows95Window} from "./Windows95Window";
import {formatTimestampToHHMMSS} from "../../engine/HelperFunctions/formatTimestampToHHMMSS";
import { TutorialStageComponent } from "../Components/TutorialStageComponent";
import { HospitalNetCore } from "../Logic/HospitalNetCore";
import { Windows95 } from "../States/Windows95";
import { closeFullscreen, getIsFullscreen, openFullscreen } from "../../engine/HelperFunctions/fullscreenFunctions";
import { NotificationsColumn } from "./NotificationsColumn";
import { INotification } from "../Types/INotification";
import { PlayerDataSingleton } from "../Logic/PlayerDataSingleton";
import { formatTimestampAs12HrClock } from "../../engine/HelperFunctions/formatTimestampAs12HrClock";

export class Windows95Taskbar extends GameObject {

    private lastUpdated: number = Date.now();
    private timeText: Text;

    private startButtonPressed: boolean = false;
    private startButton: Sprite = null;
    private startMenuContainer: Container = null;

    private notificationsSystem: NotificationsColumn;

    private windowObjsPool: Array<{
        container: GameObject;
        text: Text;
        icon: Sprite;
        bg: Sprite;
    }> = [];

    private windowState: Array<IWindowState<Windows95Window>> = [];

    public setWindowsState(_arr: Array<IWindowState<Windows95Window>>): void {
        this.windowState = _arr;
        let handledSelected: boolean = false;
        for(let i = 0; i < this.windowObjsPool.length; i++) {
            this.windowObjsPool[i].bg.visible = false;
        }

        const width = Math.min(
            Math.max(
                (tsthreeConfig.width - 134) / (_arr.filter((e) => !e.closed)).length,
                50
            ),
            (ENGINE.getPIXIResource("taskbar-window-bg") as Texture).width
        );

        for(let i = 0, objPoolInd = 0; i < _arr.length; i++) {
            if(
                _arr[i] && _arr[i].closed == false &&
                this.windowObjsPool[objPoolInd]
            ) {
                let component = this.windowObjsPool[objPoolInd]?.container?.getComponent(TutorialStageComponent);
                if(component)
                    component.tutorialStageId = `${_arr[i].id}_TaskbarTutorial`;
                this.windowObjsPool[objPoolInd].bg.visible = true;
                this.windowObjsPool[objPoolInd].icon.texture = _arr[i].icon;
                this.windowObjsPool[objPoolInd].bg.width = width;
                this.windowObjsPool[objPoolInd].container.position.set(
                    this.startButton.position.x + this.startButton.width + 2 + (objPoolInd * (width + 2)),
                    this.windowObjsPool[objPoolInd].container.y,
                );

                if(_arr[i].selected) {
                    _arr[i].windowObj.headerBg.visible = true;
                    _arr[i].windowObj.headerBgGrey.visible = false;
                } else {
                    _arr[i].windowObj.headerBg.visible = false;
                    _arr[i].windowObj.headerBgGrey.visible = true;
                }

                this.windowObjsPool[objPoolInd].text.text = _arr[i].title;
                this.windowObjsPool[objPoolInd].text.updateText(false);
                if(this.windowObjsPool[objPoolInd].text.width > this.windowObjsPool[objPoolInd].bg.width - 16) {
                    this.windowObjsPool[objPoolInd].text.text = _arr[i].title.substring(
                        0,
                        _arr[i].selected ? 22 : 30
                    ) + "...";
                } else {
                    this.windowObjsPool[objPoolInd].text.text = _arr[i].title;
                }

                if(_arr[i].selected && !handledSelected) {
                    this.selectWindow(objPoolInd);
                    handledSelected = true;
                } else {
                    this.unselectWindow(objPoolInd);
                }
                objPoolInd++;
            } else if(this.windowObjsPool[objPoolInd]) {
                this.windowObjsPool[objPoolInd].bg.visible = false;
            }
        }

        // for(let i = 0; i < this.windowObjsPool.length; i++) {
        //     if(_arr[i] && _arr[i].closed == false) {
        //         this.windowObjsPool[i].bg.visible = true;
        //         this.windowObjsPool[i].icon.texture = _arr[i].icon;
        //
        //         this.windowObjsPool[i].text.text = _arr[i].title;
        //         this.windowObjsPool[i].text.updateText(false);
        //         if(this.windowObjsPool[i].text.width > this.windowObjsPool[i].bg.width - 16) {
        //             this.windowObjsPool[i].text.text = _arr[i].title.substring(
        //                 0,
        //                 _arr[i].selected ? 22 : 30
        //             ) + "...";
        //         } else {
        //             this.windowObjsPool[i].text.text = _arr[i].title;
        //         }
        //
        //         if(_arr[i].selected) {
        //             this.selectWindow(i);
        //         } else {
        //             this.unselectWindow(i);
        //         }
        //     } else {
        //         this.windowObjsPool[i].bg.visible = false;
        //     }
        // }
        // this.windowState = _arr;
    }

    public removeWindow(ind: number): void {
        // this.windowObjsPool[ind].bg.parent.removeChild(this.windowObjsPool[ind].bg);
    }

    public unselectWindow(ind: number): void {
        if(this.windowState[ind]) {
            this.windowState[ind].selected = false;
            this.windowState[ind].windowObj.hasContext = false;
        }
        this.windowObjsPool[ind].text.style.fontFamily = GAME_FONT;
        this.windowObjsPool[ind].bg.texture = ENGINE.getPIXIResource(
            "taskbar-window-bg"
        ) as Texture;
    }

    public selectWindow(ind: number): void {
        if(this.windowState[ind]) {
            this.windowState[ind].selected = true;
            this.windowState[ind].windowObj.hasContext = true;
        }
        this.windowObjsPool[ind].text.style.fontFamily = GAME_FONT_BOLD;
        this.windowObjsPool[ind].bg.texture = ENGINE.getPIXIResource(
            "taskbar-window-bg-selected"
        ) as Texture;
        // this.windowObjsPool[ind].text.style.fill = ;
    }

    public setStartButtonClicked(_bool: boolean): void {
        this.startButtonPressed = _bool;
        this.startMenuContainer.visible = this.startButtonPressed;
        if(this.startButtonPressed) {
            this.startButton.texture =
                ENGINE.getPIXIResource("startbutton-pressed") as Texture;
        } else {
            this.startButton.texture =
                ENGINE.getPIXIResource("startbutton") as Texture;
        }
    }

    constructor(
        settings: {
            onStartButtonClicked: () => void;
            onStartMenuItemSelected: (index: number) => void;
            onWindowSelected: (_state: IWindowState<Windows95Window>) => void;
            startMenuEntries: Array<{
                id: string;
                text: string;
                icon: Texture;
            }>
        }
    ) {
        super();

        const bg = new NineSlicePlane(
            ENGINE.getPIXIResource("taskbar-nineslice") as Texture,
            0,
            1,
            0,
            0
        );
        bg.position.set(0, -bg.height);
        bg.width = tsthreeConfig.width;
        this.addChild(bg);

        const startButton = this.startButton = new Sprite(
            ENGINE.getPIXIResource("startbutton") as Texture,
        );
        startButton.anchor.set(0, 1);
        startButton.position.set( 2, -2);
        this.addChild(startButton);
        buttonify(startButton, {
            onFire: () => {
                this.setStartButtonClicked(!this.startButtonPressed);
                settings.onStartButtonClicked();
            }
        });

        const startMenuContainer = this.startMenuContainer = new Container();
        startMenuContainer.position.set(2, 0);
        startMenuContainer.visible = false;
        const startMenuBg = new NineSlicePlane(ENGINE.getPIXIResource("button") as Texture);
        startMenuBg.width = 165;
        startMenuBg.height = (settings.startMenuEntries.length * 36) + 4;
        startMenuBg.position.set(0, -(startMenuBg.height) - (startButton.height) - 4);
        startMenuContainer.addChild(startMenuBg);
        const startMenuSidePanelBgGraphic = new Graphics();
        startMenuSidePanelBgGraphic.beginFill(0x808080);
        startMenuSidePanelBgGraphic.drawRect(2, 2, 24, startMenuBg.height - 4);
        startMenuSidePanelBgGraphic.endFill();
        startMenuBg.addChild(startMenuSidePanelBgGraphic);
        const startMenuSidePanelBg = new Sprite(
            ENGINE.getPIXIResource("doctos-startmenu-bg") as Texture
        );
        startMenuSidePanelBg.anchor.set(0, 1);
        startMenuSidePanelBg.position.set(2, startMenuBg.height - 2);
        startMenuBg.addChild(startMenuSidePanelBg);

        const startMenuSelectedEntryGraphic = new Graphics();
        startMenuSelectedEntryGraphic.beginFill(0x0000ff);
        startMenuSelectedEntryGraphic.drawRect(0, 0, startMenuBg.width - 32, 36);
        startMenuSelectedEntryGraphic.position.set(32 - 4, 2);
        startMenuSelectedEntryGraphic.visible = false;
        startMenuBg.addChild(startMenuSelectedEntryGraphic);
        let selectedEntry = -1;
        settings.startMenuEntries.forEach((e, i) => {
            const container = new Container();
            container.position.set(32, (36 * i));
            buttonify(container, {
                onFire: () => {
                    settings.onStartMenuItemSelected(i);
                    this.setStartButtonClicked(false);
                },
                onPointerOut: () => {
                    selectedEntry = -1;
                    startMenuSelectedEntryGraphic.visible = false;
                    entryText.style.fill = 0x000000;
                },
                onPointerOver: () => {
                    if(selectedEntry != i) {
                        selectedEntry = i;
                        startMenuSelectedEntryGraphic.visible = true;
                        startMenuSelectedEntryGraphic.position.set(
                            startMenuSelectedEntryGraphic.position.x,
                            2 + (36 * i)
                        );
                        entryText.style.fill = 0xffffff;
                    }
                }
            });

            const icon = new Sprite(e.icon);
            icon.position.set(0, 8);
            HelperFunctions.smartScale2D(
                {
                    x: 24,
                    y: 24,
                },
                icon
            );
            container.addChild(icon);

            const entryText = new Text(e.text, new TextStyle({
                fontFamily: GAME_FONT,
                fontSize: 11,
                fill: 0x000000,
            }));
            entryText.anchor.set(0, 0.5);
            entryText.position.set(
                icon.position.x + 32,
                icon.position.y + (icon.height * 0.5),
            );
            container.addChild(entryText);
            startMenuBg.addChild(container);
            container.hitArea = new Rectangle(
                -4, 0,
                startMenuBg.width - container.position.x, 36
            );
        });
        this.addChild(startMenuContainer);

        const timeSectionBg = new NineSlicePlane(
            ENGINE.getPIXIResource("taskbar-timeiconbg-nineslice") as Texture
        );
        timeSectionBg.width = 53 + 24;
        timeSectionBg.height = 22;
        timeSectionBg.position.set(
            bg.width - timeSectionBg.width - 2,
            -(timeSectionBg.height) - 2
        );
        this.addChild(timeSectionBg);

        const time: Text = this.timeText = new Text(
            PlayerDataSingleton.getUse24HrClock() ?
                formatTimestampToHHMMSS(PlayerDataSingleton.getGameTime())
                :
                formatTimestampAs12HrClock(PlayerDataSingleton.getGameTime()),
            new TextStyle({
                fill: 0x000000,
                fontFamily: GAME_FONT,
                align: "center",
                fontSize: 11,
            })
        );
        time.position.set(timeSectionBg.width - 26, (timeSectionBg.height / 2));
        time.anchor.set(0.5, 0.5);
        timeSectionBg.addChild(time);

        // const connectionStatusIcon = new Sprite(ENGINE.getPIXIResource("doctorstats-icon") as Texture);
        // connectionStatusIcon.alpha = 0.4;
        // connectionStatusIcon.anchor.set(1, 0.5);
        // connectionStatusIcon.position.set(
        //     timeSectionBg.width + -2 + -time.width + -8,
        //     timeSectionBg.height * 0.5,
        // );
        // timeSectionBg.addChild(connectionStatusIcon);
        // const connectionStatusGraphic_connected = new Graphics();
        // connectionStatusGraphic_connected.lineStyle(3, 0x00dd00);
        // connectionStatusGraphic_connected.moveTo(connectionStatusIcon.width * 0.2, connectionStatusIcon.height * 0.75);
        // connectionStatusGraphic_connected.lineTo(connectionStatusIcon.width * 0.6, connectionStatusIcon.height);
        // connectionStatusGraphic_connected.lineTo(connectionStatusIcon.width * 1, connectionStatusIcon.height * 0.2);
        // connectionStatusGraphic_connected.visible = false;
        // connectionStatusGraphic_connected.position.set(
        //     connectionStatusIcon.position.x + (connectionStatusIcon.width * -connectionStatusIcon.anchor.x),
        //     connectionStatusIcon.position.y + (connectionStatusIcon.height * -connectionStatusIcon.anchor.y),
        // );
        // timeSectionBg.addChild(connectionStatusGraphic_connected);

        // const connectionStatusGraphic_disconnected = new Graphics();
        // connectionStatusGraphic_disconnected.lineStyle(2, 0xff0000);
        // connectionStatusGraphic_disconnected.moveTo(0, 0);
        // connectionStatusGraphic_disconnected.lineTo(connectionStatusIcon.width, connectionStatusIcon.height);
        // connectionStatusGraphic_disconnected.moveTo(connectionStatusIcon.width, 0);
        // connectionStatusGraphic_disconnected.lineTo(0, connectionStatusIcon.height);
        // connectionStatusGraphic_disconnected.visible = true;
        // connectionStatusGraphic_disconnected.position.set(
        //     connectionStatusIcon.position.x + (connectionStatusIcon.width * -connectionStatusIcon.anchor.x),
        //     connectionStatusIcon.position.y + (connectionStatusIcon.height * -connectionStatusIcon.anchor.y),
        // );
        // timeSectionBg.addChild(connectionStatusGraphic_disconnected);

        const fullscreenIcon = new Sprite(
            !getIsFullscreen() ?
                ENGINE.getTexture("fullscreen-icon") :
                ENGINE.getTexture("unfullscreen-icon")
        );
        fullscreenIcon.alpha = 1;
        fullscreenIcon.anchor.set(1, 0.5);
        fullscreenIcon.position.set(
            timeSectionBg.width + -2 + -time.width + -8,
            timeSectionBg.height * 0.5,
        );
        let antiSpam = false;

        buttonify(fullscreenIcon, {
            onFire: () => {


                if(antiSpam || this.getComponent(TutorialStageComponent)?.isActive) return;
                antiSpam = true;

                if(!getIsFullscreen()) { // if GOING to fullscreen
                    return openFullscreen().catch().finally(() => {
                        // refreshState();
                        antiSpam = false;
                    });
                } else {
                    closeFullscreen();
                    setTimeout(() => {
                        if(!antiSpam) return;
                        (function refreshState() {
                            ENGINE.resizeRenderer(
                                window.innerWidth * 0.60,
                                window.innerHeight * 0.60,
                            );
                            ENGINE.changeState(new Windows95(
                                (ENGINE.getActiveState() as Windows95)
                                    .extractInitialWindowState()
                            ));
                        })();
                        antiSpam = false;
                    }, 17);
                }

            }
        });
        timeSectionBg.addChild(fullscreenIcon);

        const notificationsSystem =
            this.notificationsSystem =
                new NotificationsColumn();
        notificationsSystem.position.set(tsthreeConfig.width, 0);
        this.addChild(notificationsSystem);

        HospitalNetCore.getVersion()
            .then((e) => {
                if(!e) {
                    console.error("Core version was unreachable");
                    // connectionStatusIcon.alpha = 0.2;
                    return;
                }
                console.log("Core version is %s", e);
                // connectionStatusIcon.alpha = 1;
                // connectionStatusGraphic_connected.visible = true;
                // connectionStatusGraphic_disconnected.visible = false;
            })
            .catch((err) => {
                // connectionStatusIcon.alpha = 0.2;
                // connectionStatusGraphic_connected.visible = false;
                // connectionStatusGraphic_disconnected.visible = true;
            });

        const windowBgs: Sprite[] = [];
        for(let i = 0; i < 15; i++) {
            const windowContainer = new GameObject();
            windowContainer.addComponent(new TutorialStageComponent({
                id: "TaskbarWindow"
            }));
            this.addChild(windowContainer);

            const windowBg = new Sprite(
                ENGINE.getPIXIResource("taskbar-window-bg") as Texture
            );
            // windowBg.anchor.set(0)
            windowContainer.position.set(
                // startButton.position.x + startButton.width + 2 + (i * (windowBg.width + 2)),
                startButton.position.x + startButton.width + 2 + (i * (windowBg.width + 2)),
                -windowBg.height - 2
            );
            windowContainer.addChild(windowBg);

            const icon = new Sprite(null);
            icon.position.set(4, 3);
            icon.width = icon.height = 16;
            windowBg.addChild(icon);

            const name = new Text("", new TextStyle({
                fill: 0x000000,
                fontFamily: GAME_FONT,
                align: "left",
                fontSize: 11,
            }));
            name.position.set(24, 4);
            windowBg.addChild(name);

            const mask = new Graphics();
            mask.beginFill(0xff0000);
            mask.drawRect(2, 2, windowBg.width - 8, windowBg.height - 4);
            mask.endFill();
            name.mask = mask;
            windowBg.addChild(mask);

            buttonify(windowBg, {
                disableButtonMode: true,
                onFire: () => {
                    // adjust for invisible
                    const visibleWindows =
                        this.windowState.filter((e, j) => {
                            return !e.closed;
                        });
                    for(let i = 0; i < windowBgs.length; i++) {
                        this.unselectWindow(i);
                    }
                    this.selectWindow(i);
                    settings.onWindowSelected(visibleWindows[i]);
                    windowContainer.getComponent(TutorialStageComponent)?.onActivate?.();
                }
            });

            windowBg.visible = false;
            windowBgs.push(windowBg);
            this.windowObjsPool.push({
                container: windowContainer,
                text: name,
                icon: icon,
                bg: windowBg,
            });
        }
    }

    public hideNotification(
        _notification: INotification | string
    ): void {
        if(typeof _notification === "string") {
            this.notificationsSystem.hideNotification(_notification);
        } else {
            this.notificationsSystem.hideNotification(_notification.id);
        }
    }

    public showNotification(
        _notification: INotification
    ): void {
        this.notificationsSystem.showNotification(_notification);
    }

    onStep(_dt: number) {
        super.onStep(_dt);
        if(Date.now() >= this.lastUpdated + (1000 * 1)) {
            this.timeText.text =
                PlayerDataSingleton.getUse24HrClock() ?
                    formatTimestampToHHMMSS(PlayerDataSingleton.getGameTime())
                    :
                    formatTimestampAs12HrClock(PlayerDataSingleton.getGameTime());
        }
    }
}